import type { ButtonHTMLAttributes } from 'react';
import { Icon, type IconName } from './Icon';

export type IconButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  name: IconName;
  size?: number;
  label?: string;
};

export function IconButton({
  name,
  size = 16,
  label,
  className = '',
  title,
  ...rest
}: IconButtonProps) {
  return (
    <button
      type="button"
      className={`icon-btn ${className}`}
      title={title ?? label}
      aria-label={label ?? title}
      {...rest}
    >
      <Icon name={name} size={size} />
    </button>
  );
}
